import { FlexBox } from 'components/Box'
import { Link } from 'components/Link'
import { FullLogotype, IconYieldbird } from 'features/layout/components/Logo'
import { useAuthUser } from 'features/user'
import { ROUTES } from 'routes'

export const Logo = (): React.JSX.Element => {
  const {
    helpers: { isEmployeeView },
  } = useAuthUser()

  return (
    <FlexBox
      axis='x'
      sx={{ mx: 1 }}
    >
      <Link
        sx={{ height: 24 }}
        to={ROUTES.BASE.ROOT}
      >
        {isEmployeeView ? <FullLogotype /> : <IconYieldbird />}
      </Link>
    </FlexBox>
  )
}
